module.exports = __webpack_public_path__ + "img/prepodavaniye.95d2f0fd.jpg";